import React from "react";

const NoData = ({title}) => {
return(
    <div className="row">
        <div className="col-12">
            <div className="noDataMsg">
                <h4>{title}</h4>
            </div>
        </div>
    </div>
)
}
export default NoData